import React from "react";
import { Element } from "react-scroll";

const Error = ({ message }) => {
  return (
    <Element name="error">
      <div
        className="common_error-text"
        style={{ marginTop: 20, marginBottom: 0 }}
        role="alert"
      >
        {message}
      </div>
    </Element>
  );
}

export default Error;
